export function isSalesman(role) {
  return role === "salesman" ? true : false;
}
